import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import config from '../configuration/config.json';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Base64 } from 'js-base64';
import './IDProofing.css';
import { Row, Col, Alert, Button } from 'react-bootstrap';

Base64.extendUint8Array();

function StartIssuance() {
    const title = 'goID ID Proofing Portal';
    const [applink, setApplink] = useState("");
    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    let { aid } = useParams();
    const navigate = useNavigate();
    const [isAppOpened, setisAppOpened] = useState(false);
    const [appMode, setappMode] = useState("");

    useEffect(() => {
        getIssuanceDeeplink();
    }, []);

    async function getIssuanceDeeplink() {
        try {
            let headers = {
                'Authorization': "Bearer " + config.idproofing.token
            };
            const response = await axios.request({
                method: 'GET',
                url: config.idproofing.apibaseurl + "idproofing/ocr/sed/" + aid,
                headers: headers,
                responseType: 'application/json'
            });

            if (response.status == 200) {
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse);
                let applinkd = jsonData.redirectUrl;
                setApplink(applinkd);
                setappMode(jsonData.appMode);

            } else {
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse)
                setErrorMessage(jsonData.message);
                setShow(true);
            }
        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else { 
                setErrorMessage(e.message);
            }
            setShow(true);
        }
    }

    async function openwebShare(text) {
        try {

           // let resultURL = config.idproofing.baseurl + "idproofing/verification/" + aid;

            const shareData = {
                text: text,
               // url: resultURL,
            };

            await navigator.share(shareData);
        } catch (e) {
            setErrorMessage(e.message);
            setShow(true);
        }
    }

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <main className="mainbg">
                <div class="container-fluid  text-center">
                    <div class="row">
                        <div class="col bannerdisplay">
                            
                            <div className="headerdiv">
                                <h1 className="headerdisplay">{title}</h1>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col scancontentarea">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">

                                            <div class="loader-container">
                                                <div class="">
                                                            {applink === "" ? <span class="loading-text dots">Processing</span> :
                                                                <div>
                                                                       {!isAppOpened &&
                                                                       <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                                                                        <p>
                                                                            <div><span>KYC completed.</span></div>
                                                                            <div><span>Click to issue the credential to your TOPPAN enabled app.</span></div>
                                                                        </p>
                                                                       </div>
}
                                                                    {!isAppOpened &&

                                                                            <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">

                                                                                <div>
                                                                                    <Button className="btn btn-primary btn-lg px-4 gap-3"
                                                                                        type="button"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            /*if (appMode == 'D') {
                                                                                                window.location.replace(applink);
                                                                                            } else {
                                                                                                openwebShare(applink)
                                                                                            }*/
                                                                                            window.location.replace(applink);
                                                                                            setisAppOpened(true);
                                                                                        }}
                                                                                    >
                                                                                        <span className="px-2">Issue</span><br></br>
                                                                                         <span className="px-2">photoID</span>
                                                                                    </Button>
                                                                                </div>
                                                                            </div>

                                                                       
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                            </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </main>
            <Alert show={show} variant="danger" onClose={() => setShow(false)} dismissible>
                <Alert.Heading>Error!</Alert.Heading>
                <p>
                    {errorMessage}.
                </p>
            </Alert>
        </>
    );
}

export default StartIssuance;
